import React from 'react';
import { Tooltip, Typography } from 'antd';
import styles from './NameBlock.module.scss';
import { getAttachmentNameWithExtension } from '../../../../helpers/getAttachmentNameWithExtension';

const { Text } = Typography;

const NameBlock = ({ attachment, getAttachmentUrl }) => {
  const handleDownload = async () => {
    const url = await getAttachmentUrl(attachment);

    const attachName = getAttachmentNameWithExtension(attachment);

    if (url) {
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', attachName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <div className={styles.fileNameWrap}>
      <Tooltip
        title={`Скачать${attachment.name ? ` "${attachment.name}"` : ''}`}
        placement="topLeft"
      >
        <Text
          className={styles.fileName}
          onClick={handleDownload}
        >
          {attachment.nameWithoutExt || 'Без имени'}
        </Text>
      </Tooltip>

      {attachment?.type?.name && (
        <Text className={styles.fileType}>
          <Text className={styles.accent}>Тип: </Text>
          <Tooltip
            title={
              attachment.type.id === 1
                ? 'Общие'
                : attachment.type.id === 2
                ? 'Подтверждение односторонней передачи'
                : null
            }
          >
            {attachment.type.name}
          </Tooltip>
        </Text>
      )}
    </div>
  );
};

export default NameBlock;
